import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { type Schedule, WEEKDAY_LABELS } from '@brimostech/shared';

export function formatDate(iso: string): string {
  return format(parseISO(iso), 'dd/MM/yyyy', { locale: ptBR });
}

export function formatDateTime(iso: string): string {
  return format(parseISO(iso), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

export function formatRelative(iso: string): string {
  return formatDistanceToNow(parseISO(iso), { locale: ptBR, addSuffix: true });
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(value);
}

export function firstName(fullName: string): string {
  return fullName.trim().split(/\s+/)[0] ?? fullName;
}

export function formatSchedule(schedule: Schedule | null): string {
  if (!schedule) return 'Sem restrição de horário';
  const days = [...schedule.days]
    .sort((a, b) => a - b)
    .map((d) => WEEKDAY_LABELS[d])
    .join(', ');
  return `${days} · ${schedule.from} às ${schedule.to}`;
}

/** yyyy-MM-dd for <input type="date"> from an ISO date or datetime. */
export function toDateInput(iso: string | null | undefined): string {
  return iso ? iso.slice(0, 10) : '';
}

/** Seconds -> "2d 3h" / "3h 12min" / "12min". */
export function formatUptime(seconds: number | null): string {
  if (seconds === null) return '—';
  const days = Math.floor(seconds / 86400);
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}min`;
  return `${minutes}min`;
}

/** Value of a `datetime-local` input (minute precision) for an ISO instant; empty when absent. */
export function toDateTimeInput(iso: string | undefined): string {
  return iso ? iso.slice(0, 16) : '';
}

/** ISO instant of a `datetime-local` value; undefined when the input is empty. */
export function fromDateTimeInput(value: string): string | undefined {
  return value ? new Date(value).toISOString() : undefined;
}
